/**
 * @file: getDefectiveLevelOfItemList.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { getDefectiveLevelFrom } from '@euler/functions/getDefectiveLevel';
import { AnyItemWithDefectiveInfo, DefectiveLevel } from '@euler/model';

export const getDefectiveLevelOfItemList = (
  items: AnyItemWithDefectiveInfo[],
) => {
  let defectiveLevel: DefectiveLevel = DefectiveLevel.Fine;
  for (const item of items) {
    const value = getDefectiveLevelFrom(item);
    if (value > defectiveLevel) {
      defectiveLevel = value;
    }
  }
  return defectiveLevel;
};
